import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import WeekdaysPicker from '../WeekdaysPicker/WeekdaysPicker';

export type Props = {
  control: Control<any>;
  name: string;
};

export default function ControlledWeekdaysPicker({ control, name }: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <WeekdaysPicker
          value={field.value}
          onChange={(value) => {
            field.onChange(value);
          }}
        />
      )}
    />
  );
}
